import React from 'react';
import classNames from 'classnames';

import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { Divider } from 'Src/feature/divider/Divider';

import styles from './ProgressStepper.module.scss';

interface ProgressStepperProps {
  activeStep: number;
  steps: string[];
}

const ProgressStepper: React.FC<ProgressStepperProps> = ({ activeStep, steps }) => (
  <Flex horizontal fullWidth alignItems="center" justifyContent="center" gap="sm">
    {steps.map((label, index) => {
      const isActive = activeStep === index;
      const isCompleted = activeStep < index;
      const hasDivider = index !== (steps.length -1);
      return (
        <React.Fragment key={label}>
          <Copy
            variant="body"
            size="lg"
            weight="bold"
            align="center"
            uppercase
            className={classNames(styles['label'], {
              [styles['active']]: isActive,
              [styles['completed']]: isCompleted,
            })}
            value={label}
          />
          { hasDivider && (
            <Divider
              className={classNames(styles['connector_line'], {
                [styles['active']]: isActive,
                [styles['completed']]: isCompleted,
              })}
            />
          )}
        </React.Fragment>
      );
    })}
  </Flex>
);


export default ProgressStepper;
